import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = {
  class: "grow"
};
const _hoisted_3 = {
  key: 0,
  class: "ml-1 flex items-center"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0,
  class: "ml-1 flex items-center"
};
import PlayerComponent from "@/modules/team/components/Player.vue";
import PlayerForm from "@/modules/team/components/PlayerForm.vue";
import PlayerEnergy from "@/modules/team/components/PlayerEnergy.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerList',
  props: {
    players: null,
    noAction: {
      type: Boolean
    },
    showTalent: {
      type: Boolean
    },
    showMarketValue: {
      type: Boolean
    },
    nextMatch: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.players, player => {
        return _openBlock(), _createElementBlock("div", {
          key: player.id,
          class: "-mx-2 px-2 py-0.5 even:bg-slate-50"
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "player", _normalizeProps(_guardReactiveProps({
          player
        })), () => [_createVNode(PlayerComponent, {
          player: player,
          class: "grow",
          "hide-constitution": "",
          "show-talent": __props.showTalent,
          "next-match": __props.nextMatch
        }, null, 8, ["player", "show-talent", "next-match"])])]), !__props.noAction ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "action", _normalizeProps(_guardReactiveProps({
          player
        })), () => [__props.showMarketValue ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$money(player.marketValue)), 1)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(PlayerForm, {
          player: player,
          type: "progress",
          class: "w-4"
        }, null, 8, ["player"]), _createVNode(PlayerEnergy, {
          player: player,
          type: "progress",
          class: "ml-2 w-8"
        }, null, 8, ["player"])], 64))]), _ctx.$slots.afterAction ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_renderSlot(_ctx.$slots, "afterAction", _normalizeProps(_guardReactiveProps({
          player
        })))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
      }), 128))]);
    };
  }
});